import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"

const api = new APIClient();

// Get All
export const getEvent = () => api.get(url.GET_EVENT, {});

// Add
export const addEvent = (payload: any) => api.create(`${url.ADD_EVENT}/${payload.calendarId}`, payload)

// Get Detail
export const getDetail = (id: string) => api.get(`${url.GET_DETAIL_EVENT}/${id}`, {})

// Update
export const updateEvent = (id: string, payload: any) => api.put(`${url.GET_DETAIL_EVENT}/${id}`, payload)

// Delete
export const deleteEvent = (id: string) => api.delete(`${url.GET_DETAIL_EVENT}/${id}`, {})

// Delete
export const getUserEvents = () => api.get(url.GET_USER_EVENTS, {})
export const checkAvailable = (params: any) => api.get(url.CHECK_AVAILABLE, { params })